import { useCallback, useMemo } from 'react';
import { useLocationGroupStore } from '@frontend/scope';
import { createNamespacedWetagHooks } from '@frontend/wetags';
import type { PaymentsTags } from './tags';

const PAYMENTS_NAMESPACE = 'weave-location';

function useCurrentLocationId(): string {
  const locationId = useLocationGroupStore((state) => state.selectedLocationIds[0] || '');
  return locationId;
}

export type UsePaymentsWetagProps = {
  locationId: string | undefined;
};
export const usePaymentsWetag = ({ locationId }: UsePaymentsWetagProps) => {
  const getLocationId = useCallback(() => locationId, [locationId]);
  const wetags = useMemo(() => {
    return createNamespacedWetagHooks<PaymentsTags>(PAYMENTS_NAMESPACE, useCurrentLocationId, getLocationId);
  }, [getLocationId]);

  return wetags;
};
